import { render, staticRenderFns } from "./SolutionCopyModal.vue?vue&type=template&id=c53817c8&scoped=true&"
import script from "./SolutionCopyModal.vue?vue&type=script&lang=ts&"
export * from "./SolutionCopyModal.vue?vue&type=script&lang=ts&"
import style0 from "./SolutionCopyModal.vue?vue&type=style&index=0&id=c53817c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53817c8",
  null
  
)

export default component.exports